import { render, staticRenderFns } from "./DefaultContentLayout.vue?vue&type=template&id=6802b90a"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6802b90a')) {
      api.createRecord('6802b90a', component.options)
    } else {
      api.reload('6802b90a', component.options)
    }
    module.hot.accept("./DefaultContentLayout.vue?vue&type=template&id=6802b90a", function () {
      api.rerender('6802b90a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scaffold/DefaultContentLayout.vue"
export default component.exports